export default {"src":"/_next/static/media/aer-lingus-logo.933a3794.svg","height":42,"width":384,"blurWidth":0,"blurHeight":0};